import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectsubscriptionsQueryItems } from '../../../../redux/subscriptions/selector';
import { selectprogramsListItems, selectprogramsQueryItems } from '../../../../redux/programs/selector';
import { subscriptions } from '../../../../redux/subscriptions/action';
import { programs } from '../../../../redux/programs/action';
import PageLoader from '../../../../components/PageLoader';
import ChangeSubscriptionComponent from '../components/change-subscription/change-signature.component';

const DIGIITAIChangeSubscription = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params: any = useParams();
  const queryItems = useSelector(selectsubscriptionsQueryItems);
  const programItems = useSelector(selectprogramsListItems);
  const programQueryItems = useSelector(selectprogramsQueryItems);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);
  const [programData, setProgramData] = useState({
    OwnerName: '',
    Name: '',
    Description: '',
    Amount: 0,
    Validity: '',
    DBaaSProgram: [
      {
        Price: 0,
        ProgramDuration: '',
      },
    ],
  });
  const [selectedSubscriptions, setSelectedSubscriptions] = useState<any>({
    Email: '',
    PhoneNumber: '',
    Name: '',
    Description: '',
    ownerType: 'DBaasProgramPolicy',
    Amount: 0,
    Validity: '',
  });

  const fetchSubscriptionsById = () => {
    dispatch(
      subscriptions.query({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/query`,
        entity: 'subscriptions',
        jsonData: {
          Records: [
            {
              Id: params?.id,
            },
          ],
        },
      })
    ).then(() => {
      setIsQuery(true);
    });
  };

  useEffect(() => {
    if (programQueryItems?.result) {
      setProgramData(programQueryItems.result.items);
    }
  }, [programQueryItems]);

  const handleOwnerIdChange = async (ownerId: string) => {
    await dispatch(
      programs.query({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/query`,
        entity: 'programs',
        jsonData: {
          Records: [{ Id: ownerId }],
        },
      })
    );
  };

  const handleInnerFormChange = (event: any, field: string) => {
    if (field === 'OwnerId') {
      handleOwnerIdChange(event);
      setSelectedSubscriptions({ ...selectedSubscriptions, [field]: event });
    } else {
      setSelectedSubscriptions({ ...selectedSubscriptions, [field]: event });
    }
  };

  useEffect(() => {
    dispatch(
      programs.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/list`,
        entity: 'programs',
        jsonData: {},
      })
    ).then(() => {
      if (params?.id > 0) {
        fetchSubscriptionsById();
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectedSubscriptions(queryItems?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = (event: any) => {
    event.preventDefault();
    setShowConfirmationModal(true); // Show confirmation modal before submitting
  };

  const proceedWithSubmit = async () => {
    setShowConfirmationModal(false); // Hide the modal

    const subscriptionData = {
      Id: selectedSubscriptions?.Id,
      Email: selectedSubscriptions?.Email,
      PhoneNumber: selectedSubscriptions?.PhoneNumber,
      CurrencyCode: selectedSubscriptions?.CurrencyCode,
      OwnerType: 'DBaasProgram',
      OwnerId: selectedSubscriptions?.OwnerId,
      OwnerName: programData?.Name,
      Name: programData?.Name,
      Description: programData?.Description,
      Amount: programData?.DBaaSProgram[0]?.Price,
      Validity: programData?.DBaaSProgram[0]?.ProgramDuration,
      BusinessName: selectedSubscriptions?.BusinessName,
      UserProfileId: selectedSubscriptions?.UserProfileId || 0,
      CustomerId: selectedSubscriptions?.CustomerId || null,
    };

    if (params?.id > 0) {
      await dispatch(subscriptions.resetAction({ actionType: 'update' }));
      await dispatch(
        subscriptions.update({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/change-from-one-to-another`,
          entity: 'subscriptions',
          jsonData: {
            Records: [subscriptionData],
          },
        })
      ).then(() => {
        back();
      });
    }
  };

  const back = () => {
    navigate('/digiit-ai/subscriptions');
  };

  return (
    <>
      {isLoading ? (
        <PageLoader />
      ) : (
        <>
          <ChangeSubscriptionComponent
            handleInnerFormChange={handleInnerFormChange}
            selectedSubscriptions={selectedSubscriptions}
            back={back}
            id={params?.id}
            handleFormSubmit={handleFormSubmit}
            programs={programItems?.result?.items}
          />
          {showConfirmationModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white p-6 rounded shadow">
               
                <p>Are you sure Do you want to change the subscription?</p>
                <div className="mt-4 flex justify-end space-x-2">
                  <button
                    onClick={() => setShowConfirmationModal(false)}
                    className="px-4 py-2 bg-gray-500 text-white rounded"
                  >
                    No
                  </button>
                  <button
                    onClick={proceedWithSubmit}
                    className="px-4 py-2 bg-blue-600 text-white rounded"
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default DIGIITAIChangeSubscription;
